import { TThunkAction } from '../../types/redux';
import { ENewReviewModalStep } from '../../types/newReview';
import { setNewReviewFormStep } from './stepActionsTypes';
import { addReviewActions } from './addReviewActions';
import { trackOpenNewReviewSecondStep } from '../../analytics/newReview';
import { prepareNewReviewsSecondStepOpen } from '../../mappers/prepareNewReviews/analyticsMapper';
import { getNewbuildingRating } from '../../selectors/newbuildingInfo';
import { getUserForAnalytics } from '../../selectors/user';

export function changeStep(): TThunkAction<Promise<void>> {
  return async (dispatch, getState, context) => {
    try {
      const { custom } = context;
      const state = getState();
      const { newReview } = state;
      const {
        meta: { step },
      } = newReview;
      const user = getUserForAnalytics(state);

      if (step === ENewReviewModalStep.Rating) {
        trackOpenNewReviewSecondStep({
          siteType: custom.deviceType,
          ratings: prepareNewReviewsSecondStepOpen(newReview),
          rating: getNewbuildingRating(state),
          user,
        });
        dispatch(setNewReviewFormStep(ENewReviewModalStep.Review));
      }

      if (step === ENewReviewModalStep.Review) {
        dispatch(addReviewActions());
      }
    } catch (e) {
      dispatch(setNewReviewFormStep(ENewReviewModalStep.Error));
    }
  };
}
